import { PropsWithChildren, useCallback, useMemo, useState } from "react"

import { AuthContext } from "context/AuthContext"

export const AuthProvider: React.FC<PropsWithChildren> = ({ children }) => {
  // Backend JWT must NOT persist after logout/refresh
  const [token, setToken] = useState<string>()
  // adb2cToken is managed by MSAL in sessionStorage, we only need state for backend exchange
  const [adb2cToken, setAdb2cToken] = useState<string>()

  const unsetTokens = useCallback(() => {
    setToken(undefined)
    setAdb2cToken(undefined)
  }, [setToken, setAdb2cToken])

  const contextValue = useMemo(
    () => ({ token, setToken, adb2cToken, setAdb2cToken, unsetTokens }),
    [token, setToken, adb2cToken, setAdb2cToken, unsetTokens]
  )

  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  )
}
